import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactGA from 'react-ga';
import { Helmet } from "react-helmet";
import { withTranslation } from 'react-i18next';
import { Loading } from '../../../components'
import { indexJobDestination, unmountIndexJobDestination } from '../../../redux/actions/master/jobDestination/jobDestinationAction';
import { checkToken } from '../../../redux/actions/auth/authAction';
import { Row, Col, Card, Image, Typography, Space, Layout, message } from 'antd';
import Header from '../Header';
import Footer from '../Footer';
import '../JobPreferences.css';

const { Title, Text } = Typography;

export class Destination extends Component {
  constructor(props) {
    super(props)
  
    this.state = {
      destinationSelected: localStorage.getItem("destinationSelected") ? localStorage.getItem("destinationSelected").split(',').map(x=>+x) : []
    }
  }

  componentDidMount() {
    const { actionCheckToken, actionGetJobDestination } = this.props
    actionCheckToken((response) => {
      if(response.code === "1000"){
        return actionGetJobDestination()
      }
    })
  }

  onSelectDestination = (id) => {
    const { t } = this.props
    const { destinationSelected } = this.state
    
    const filterSelected = destinationSelected.filter(item => item === id)
    const indexOfSelected = destinationSelected.indexOf(id)
    if(filterSelected.length === 0){
      if(destinationSelected.length < 5){
        destinationSelected.push(id)
      }else{
        message.error(t('jobPreferences.destinations.msg'))
      }
    }else{
      destinationSelected.splice(indexOfSelected,1)
    }

    this.setState({ destinationSelected })
  }

  render() {
    const { getJobDestination: { data, loading }, t } = this.props
    const { destinationSelected } = this.state
    
    if(process.env.REACT_APP_ENV === "production"){
      ReactGA.pageview(`${window.location.pathname}${window.location.search}`, [], 'Jobshub - Job Preferences - Job Destination');
    }

    if(loading){
      return <Loading />
    }

    return (
      <React.Fragment>
        <Helmet>
          <title>Jobshub - Job Preferences - Job Destination</title>
        </Helmet>
        <Layout>
          <Header />
          <Row className="display-inline margin-16 mt-32">
            <Col className="pb-100 mt-64" xs={24} sm={24} md={{ span: 22, offset: 1 }}>
              <Space className="width-100 mb-32 text-align-center" direction="vertical" size="small">
                <Title className="dark-color font-weight-normal" level={3}>{t('jobPreferences.destinations.title')}</Title>
                <Text className="dark-color font-weight-normal">{t('jobPreferences.destinations.subTitle')}</Text>
              </Space>
                {
                  data?.map((item, i) =>
                    <React.Fragment key={i}>
                      <Row className="mb-16" justify="space-around" align="middle">
                        <Col span={24}>
                          <Text className="fs-13">{item.name}</Text>
                        </Col>
                      </Row>
                      <Row className="mb-32" gutter={[16, 16]}>
                        {
                          item.listDestination.map((res, i) => 
                            <Col key={i} xs={24} sm={24} md={8}>
                              <Card
                                className={ 
                                  destinationSelected.length === 0 ? 
                                    "width-100 border-radius-6"
                                  :
                                  destinationSelected.map((value) => 
                                      res.id === value ? "width-100 border-radius-6 card-selected" : "width-100 border-radius-6"
                                    )}
                                hoverable
                                bodyStyle={{ padding: 12 }}
                                onClick={() => this.onSelectDestination(res.id)}
                              >
                                <Row align="middle">
                                  <Col className="text-align-center" span={24}>
                                    <Space direction="vertical" size={0}>
                                      <Image
                                        className={!res.isDomestic ? "box-shadow" : null}
                                        width={80}
                                        height={40}
                                        src={res.flag}
                                        preview={false}
                                        style={res.isDomestic ? { objectFit: 'contain' } : null}
                                      />
                                      <Text className="fs-11">{res.name}</Text>
                                    </Space>
                                  </Col>
                                </Row>
                              </Card>
                            </Col>
                          )
                        }
                      </Row>
                    </React.Fragment>
                  )
                }
            </Col>
          </Row>
          <Footer destinationSelected={destinationSelected} />
        </Layout>
      </React.Fragment>
    )
  }
  componentWillUnmount() {
    const { unmountIndexJobDestination } = this.props
    return unmountIndexJobDestination()
  }
}

const mapStateToProps = (state) => ({
  getJobDestination: state.jobDestinationReducer
})

const mapDispatchToProps = {
  actionCheckToken: checkToken,
  actionGetJobDestination: indexJobDestination,
  unmountIndexJobDestination: unmountIndexJobDestination
}

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Destination))
